import { CardContent, Typography } from '@mui/material';

interface IProps {
  headerFields: { schoolName?: string; date?: string };
}

function SchoolTitleHeader({ headerFields }: IProps) {
  return (
    <CardContent
      sx={{ backgroundColor: 'background.default', p: 2, textAlign: 'left' }}>
      <Typography variant='h6' color='primary.dark'>
        {headerFields.schoolName}
      </Typography>
      <Typography variant='subtitle2'>{headerFields.date}</Typography>
    </CardContent>
  );
}

export default SchoolTitleHeader;
